// extracted by mini-css-extract-plugin
module.exports = {"title":"ConversationsHeader_title","heading":"ConversationsHeader_heading"};